<div class="container produtividade-v2">
  <div class="row">
    <div class="col-xs-12">
      <div class="ibox">
        <div class="ibox-title">
          <h4>Produtividade</h4>
        </div>
        <div class="ibox-content">
          <div class="row">
            <div class="col-xs-6 form-horizontal">

              <div class="form-group">
                <label for="safra-inicial" class="control-label col-xs-4">Safra inicial*</label>
                <div class="col-xs-8">
                  <select id="safra-inicial" class="form-control" ng-options="safra.descricao for safra in prod.safras track by safra.id" ng-model="prod.filter.safra_inicial">
                    <option value="">Selecione</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label for="safra-final" class="control-label col-xs-4">Safra final*</label>
                <div class="col-xs-8">
                  <select id="safra-final" class="form-control" ng-options="safra.descricao for safra in prod.safras track by safra.id" ng-model="prod.filter.safra_final">
                    <option value="">Selecione</option>
                  </select>
                </div>
              </div>

              <div class="form-group" ng-class="{'has-error': prod.filter.propriedades.length == 0}">
                <label class="control-label col-xs-4">Propriedades*</label>
                <div class="col-xs-8">
                  <ui-select multiple ng-model="prod.filter.propriedades" theme="bootstrap">
                    <ui-select-match allow-clear="true">{{$item.descricao | capitalize}}</ui-select-match>
                    <ui-select-choices repeat="propriedade in prod.propriedades | orderBy: 'descricao' | filter:{descricao: $select.search}">
                      <span ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
                    </ui-select-choices>
                  </ui-select>
                </div>
              </div>

              <div class="form-group" ng-if="!$root.parametros.nao_cliente_agrogestao">
                <label for="periodo" class="control-label col-xs-4">Período Agrícola</label>
                <div class="col-xs-8">
                  <select id="periodo" class="form-control" ng-options="periodo.descricao for periodo in prod.periodosAgricolas track by periodo.codigo" ng-model="prod.filter.periodo">
                    <option value="">Todos</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label for="atividade" class="control-label col-xs-4">Cultura*</label>
                <div class="col-xs-8">
                  <select id="atividade" class="form-control" ng-options="atividade.descricao for atividade in prod.atividades track by atividade.id" ng-model="prod.filter.atividade" ng-change="prod.handleUnidades()">
                    <option value="">Selecione</option>
                  </select>
                </div>
              </div>

              <div class="form-group" ng-show="prod.showChart()">
                <label for="tipo" class="control-label col-xs-4">Tipo</label>
                <div class="col-xs-8">
                  <select id="tipo" class="form-control" ng-options="tipo for tipo in prod.tipos" ng-model="prod.filter.tipo"></select>
                </div>
              </div>

              <div class="form-group">
                <label for="tipo" class="control-label col-xs-4">Unidade</label>
                <div class="col-xs-8">
                  <select id="tipo" class="form-control" ng-options="unidade.descricao for unidade in prod.unidades track by unidade.conversao" ng-model="prod.filter.unidade"></select>
                </div>
              </div>

              <div class="form-group" ng-show="prod.filter.isCana">
                <label for="informacao" class="control-label col-xs-4">Informação</label>
                <div class="col-xs-8">
                  <select id="informacao" class="form-control" ng-options="informacao.descricao for informacao in prod.informacoes track by informacao.id" ng-model="prod.filter.informacao"></select>
                </div>
              </div>

              <!-- data inicio -->
              <div class="form-group" ng-class="{'has-error': prod.filter.dataInicial.$invalid}">
                <label for="periodo" class="control-label col-xs-4">Data início colheita:</label>
                <div class="col-xs-8">
                  <div class="input-group">
                    <input type="text" class="form-control" readonly datepicker-options="prod.datePickerOptions"
                      uib-datepicker-popup="{{prod.popupData.format}}" ng-model="prod.filter.dataInicial"
                      is-open="prod.popupData.openedDataInicial" show-button-bar="false" datepicker-append-to-body="true"
                      id="data_inicial" name="data_inicial">
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-default" ng-click="prod.openPopupData('openedDataInicial')">
                        <i class="glyphicon glyphicon-calendar"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>

              <!-- data termino -->
              <div class="form-group" ng-class="{'has-error': prod.filter.dataFinal.$invalid}">
                <label for="periodo" class="control-label col-xs-4">Data término colheita:</label>
                <div class="col-xs-8">
                  <div class="input-group">
                    <input type="text" class="form-control" readonly datepicker-options="prod.datePickerOptions"
                      uib-datepicker-popup="{{prod.popupData.format}}" ng-model="prod.filter.dataFinal" ng-disabled="!prod.filter.dataInicial"
                      is-open="prod.popupData.openedDataFinal" show-button-bar="false" datepicker-append-to-body="true"
                      id="data_final" name="data_final">
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-default" ng-click="prod.openPopupData('openedDataFinal')">
                        <i class="glyphicon glyphicon-calendar"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button type="button"
                        class="btn-xs btn-link text-info"
                        ng-click="prod.clearFilterDatas()"
                        ng-disabled="!prod.filter.dataInicial && !prod.filter.dataFinal">
                  <span>Limpar datas</span>
                </button>
              </div>


            </div>
            <div class="col-xs-6" ng-show="prod.error">
              <div class="alert alert-danger">
                {{prod.error}}
              </div>
            </div>
            <div class="col-xs-12">
              <hr>
            </div>
          </div>

          <div class="row" ng-if="!prod.error && prod.showChart() && prod.chart.options.title">
            <div ng-class="{'col-xs-9': prod.chart.legend.length}">
              <div google-chart chart="prod.chart" style="height: 600px;"></div>
            </div>
            <div class="col-xs-3 legend" ng-if="prod.chart.legend.length">
              <div class="item" ng-repeat="item in prod.chart.legend">
                <span class="color" ng-style="item.color"></span>
                <span class="text" ng-style="item.text.style">{{item.text.content}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
